const projectData = {
   nausy: {
        id: "1",
        title: "Nausymate",
        description: "Nausymate is an E-commerce Website dedicated to paper bags that come in handy when you are feeling Nausiated. A completely recyclable solutions for those people who suffer nausea while travelling and doing other activities.This website was developed using WordPress and Elementor Page builder",
        url: "https://nausymate.com/",
        image: "https://iili.io/Df5iMX.png",
    },
    wellrooted: {
        id: "2",
        title: "WellRootedPediatrics",
        description: "WellRootedPediatrics is a project based on providing medical assistance and information through house visits or by visiting the clinic yourself. Suited for most parents that want regular checkups of there children. This website was designed and developed using WordPress and Elementor Page builder",
        url: "https://wellrootedpeds.com",
        image: "https://iili.io/Df7zV1.png",
    },
    luxe: {
        id: "3",
        title: "Luxe360BeautyHouse",
        description: "Luxe360BeautyHouse is an E-commerce website that provides beauty, cosmetics and other such products. This website was designed and developed using WordPress and Elementor Page builder",
        url: "https://luxe360beautyhouse.org",
        image: "https://iili.io/Df7BAQ.png",
    },
    cream: {
        id: 4,
        title: "Cream Digital",
        description: "Cream Digital provides digital services for customers. This website was their promotional website. It was designed and developed using WordPress and Elementor Page builder",
        url: "https://www.behance.net/gallery/146304103/Cream-Digital-Company",
        image: "https://iili.io/DfRHe2.md.png",
    },
    chute: {
        id: "5",
        title: "Chute Systems",
        description: "A website dedicated to Chute Systems and their information. A small business based in US that wanted their own website. It was developed using Wordpress and Elementor",
        url: "https://chutesourcellc.com",
        image:"https://iili.io/Df5mAl.png",
    },
   pornScience: {
        id: "6",
        title: "Porn Science",
        description: "A Reseasrch Website for Porn Science and the addictions that we face. It has citations from studies and expert's contacts so you can get help as quickly as possible. Website serves as an educational content for people",
        url: "https://porn-science.com/",
        image: "https://iili.io/Df5NMF.png",
    }};

    export default projectData;

    
    